import React from "react";

import { IPortfolio, ISimpleTeachingMaterial } from "../../../state";
import PortfolioTable from "../../../molecules/teacher/PortfolioTable";
import TeachingMaterialHeader from "../../../molecules/TeachingMaterialHeader";

import styles from "./PortfolioPreview.module.scss";

type PortfolioPreviewProps = {
  teachingMaterial: ISimpleTeachingMaterial;
  portfolio?: IPortfolio;
};

const INITIAL_PORTFOLIO = {
  id: 0,
  key_issue_answer: null,
  summary_issue_answers: null,
  lesson00_issue_answers: null,
  lesson01_issue_answers: null,
  lesson02_issue_answers: null,
  lesson03_issue_answers: null,
};

const PortfolioPreview = (props: PortfolioPreviewProps) => {
  const teachingMaterial = props.teachingMaterial;
  const portfolio: IPortfolio = React.useMemo(
    () =>
      props.portfolio ?? {
        ...INITIAL_PORTFOLIO,
        portfolio_type: teachingMaterial.portfolio_type ?? 2,
        teaching_material_id: teachingMaterial.id,
      },
    [props.portfolio, teachingMaterial],
  );

  const renderPortfolioTable = () => {
    if (!portfolio || !teachingMaterial) return;
    const portfolioTable: { [type: number]: React.ReactElement } = {
      1: (
        <>
          <PortfolioTable.Key answer={portfolio.key_issue_answer} />
          <PortfolioTable.Lesson
            portfolio={portfolio}
            teachingMaterialName={teachingMaterial.name}
          />
        </>
      ),
      2: (
        <PortfolioTable.Lesson
          portfolio={portfolio}
          teachingMaterialName={teachingMaterial.name}
        />
      ),
      7: (
        <>
          <PortfolioTable.Lesson
            portfolio={portfolio}
            teachingMaterialName={teachingMaterial.name}
          />
          <PortfolioTable.Key answer={portfolio.key_issue_answer} />
          <PortfolioTable.Summary
            answer={(() => {
              const firstSummaryAnswer = portfolio.summary_issue_answers?.find(
                answer => answer.order_num === 0,
              );
              return firstSummaryAnswer?.content ?? "";
            })()}
          />
        </>
      ),
      11: (
        <>
          <PortfolioTable.Key answer={portfolio.key_issue_answer} />
          <PortfolioTable.Lesson
            portfolio={portfolio}
            teachingMaterialName={teachingMaterial.name}
          />
        </>
      ),
      12: (
        <PortfolioTable.Lesson
          portfolio={portfolio}
          teachingMaterialName={teachingMaterial.name}
        />
      ),
      17: (
        <>
          <PortfolioTable.Lesson
            portfolio={portfolio}
            teachingMaterialName={teachingMaterial.name}
          />
          <PortfolioTable.Key answer={portfolio.key_issue_answer} />
        </>
      ),
    };
    return portfolioTable[portfolio.portfolio_type];
  };

  return (
    <div className={styles.wrapper}>
      <TeachingMaterialHeader
        teachingMaterial={teachingMaterial}
        is_portfolio
      />
      <div className={styles.table}>{renderPortfolioTable()}</div>
    </div>
  );
};

export default PortfolioPreview;
